import React from 'react';
import AmsaleHeader from '../../../../../base/ui/AmsaleHeader';
import ContentContainerLayout from './ContentContainerLayout';
import useClientsEventBookingContext from '../appointments/hooks/useClientsEventBookingContext';

// eslint-disable-next-line react/prop-types
const BookingLayout = ({ children }) => {
  const { mobileMenuOpen, setMobileMenuOpen } = useClientsEventBookingContext();
  return (
    <div>
      <AmsaleHeader setMobileMenuOpen={setMobileMenuOpen} />
      <ContentContainerLayout>
        {children}
      </ContentContainerLayout>
    </div>
  );
};
export default BookingLayout;
